import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group d-flex flex-wrap" }
const _hoisted_15 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "channel-specification" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group d-flex flex-wrap" }
const _hoisted_32 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_35 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_36 = { class: "indicator-label" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_40 = { class: "card mb-5 mb-xl-10" }
const _hoisted_41 = { class: "card-header border-0" }
const _hoisted_42 = { class: "card-title m-0" }
const _hoisted_43 = { class: "fw-boldest m-0" }
const _hoisted_44 = { class: "card-body border-top p-9" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group d-flex flex-wrap" }
const _hoisted_48 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "el-form-item__content" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "el-form-item__content" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group d-flex flex-wrap" }
const _hoisted_56 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "el-form-item__content" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-group d-flex flex-wrap" }
const _hoisted_60 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_MBTaggings = _resolveComponent("MBTaggings")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
        ])
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("channel.systemStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.status,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                        "active-value": 10,
                        "inactive-value": 25,
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("channel.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("channel.shortKey")), 1),
                  _createVNode(_component_el_form_item, { prop: "short_key" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.short_key,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.short_key) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("channel.parentChannel")), 1),
                  _createVNode(_component_el_form_item, { prop: "parent_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.parent_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.parent_id) = $event)),
                        clearable: "",
                        filterable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.parent_id, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_19,
            _createVNode(_component_MBTaggings, {
              ref: "channelSegmentationRef",
              "tagging-items": _ctx.channelSegmentationSource,
              "tagging-values": _ctx.channelSegmentationValues
            }, null, 8, ["tagging-items", "tagging-values"]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("channel.specification")), 1),
                  _createVNode(_component_el_form_item, { prop: "specification" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.specification,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.specification) = $event)),
                        "active-value": 1,
                        "inactive-value": 0,
                        placeholder: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_24, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("channel.productRequirement")), 1),
              _hoisted_25,
              _createVNode(_component_MBTaggings, {
                ref: "productRequirementRef",
                "tagging-items": _ctx.productRequirementSource,
                "tagging-values": _ctx.productRequirementValues
              }, null, 8, ["tagging-items", "tagging-values"]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("channel.fulfillmentRequirement")), 1),
              _hoisted_26,
              _createVNode(_component_MBTaggings, {
                ref: "fulfillmentRequirementRef",
                "tagging-items": _ctx.fulfillmentRequirementSource,
                "tagging-values": _ctx.fulfillmentRequirementValues
              }, null, 8, ["tagging-items", "tagging-values"]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("channel.settlementRequirement")), 1),
              _hoisted_27,
              _createVNode(_component_MBTaggings, {
                ref: "settlementRequirementRef",
                "tagging-items": _ctx.settlementRequirementSource,
                "tagging-values": _ctx.settlementRequirementValues
              }, null, 8, ["tagging-items", "tagging-values"])
            ], 512), [
              [_vShow, _ctx.formData.specification]
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("channel.quickNotes")), 1),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("channel.overallNotes")), 1),
                  _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.overall_notes,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_router_link, {
              to: '/distribution-network/distribution-channels/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_34,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, [
                _hoisted_37,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_38, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_39
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}